module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessageButton),
      expression: "localErrorMessageButton"
    }],
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessageClear)),
      expression: "localeFtc(localErrorMessageClear)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (_vm.isDataReady) ? _c('div', {
    staticClass: "w5-vds-view-wrapper"
  }, [_c('div', {
    staticClass: "font-size-120 name-in-vds"
  }, [_c('span', {
    class: 'flag-icon flag-icon-' + _vm.dataCenter.country
  }), _vm._v(" "), (_vm.Access) ? _c('span', {
    staticClass: "font-weight-500 w5-modal-link",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.changeServiceName($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.serviceName)))]) : _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.serviceName)))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "margin-top-10 font-size-95"
  }, [_c('span', {
    staticClass: "margin-right-10",
    class: {
      'text-strike': !_vm.serviceIPActive
    }
  }, [_vm._v(_vm._s(_vm.serviceIP))]), _vm._v(" "), (_vm.serviceStatus['loader']) ? _c('span', {
    staticClass: "margin-right-10",
    class: 'w5-status-color-' + _vm.serviceStatusClear
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])) + " "), _c('img', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "src": require("../../assets/img/loading-hor16.gif")
    }
  })]) : (_vm.serviceStatus['timer']) ? _c('span', {
    staticClass: "margin-right-10",
    class: 'w5-status-color-' + _vm.serviceStatusClear
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])) + " "), _c('font-awesome-icon', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "icon": "clock"
    }
  })], 1) : _c('span', {
    staticClass: "margin-right-10",
    class: 'w5-status-color-' + _vm.serviceStatusClear
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])))]), _vm._v(" "), _c('span', {
    staticClass: "margin-right-10"
  }, [_c('img', {
    attrs: {
      "src": _vm.APIServerUrl + _vm.serviceTemplate['template_image']['value'],
      "width": "18",
      "height": "18"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.serviceTemplate['template_name']['value']))])]), _vm._v(" "), _c('br', {
    staticClass: "visible-xs"
  }), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['cpu']['title'])) + ": "), _c('strong', [_vm._v(_vm._s(_vm.servicePlanInfo['cpu']['total'] ? _vm.servicePlanInfo['cpu']['total'] : _vm.servicePlanInfo['cpu']['value']) + " " + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['cpu']['for'])))]), _vm._v("\n\t\t\t\t\t   \n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['ram']['title'])) + ": "), _c('strong', [_vm._v(_vm._s(_vm.servicePlanInfo['ram']['total'] ? _vm.servicePlanInfo['ram']['total'] : _vm.servicePlanInfo['ram']['value']) + " " + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['ram']['for'])))]), _vm._v("\n\t\t\t\t\t   \n\t\t\t\t\t"), _c('br', {
    staticClass: "visible-xs"
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['disk']['title'])) + ": "), _c('strong', [_vm._v(_vm._s(_vm.servicePlanInfo['disk']['total'] ? _vm.servicePlanInfo['disk']['total'] : _vm.servicePlanInfo['disk']['value']) + " " + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['disk']['for'])))]), _vm._v("\n\t\t\t\t\t   \n\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['traff']['title'])) + ": "), _c('strong', [_vm._v(_vm._s(_vm.servicePlanInfo['traff']['value']) + " " + _vm._s(_vm._f("ftc")(_vm.servicePlanInfo['traff']['for'])))])]), _vm._v(" "), (_vm.isAccountBlockVisible) ? _c('div', {
    staticClass: "margin-top-10"
  }, [(_vm.$store.state.user_type === 'admin') ? _c('span', {
    staticClass: "margin-right-10"
  }, [_vm._v(_vm._s(_vm._f("ftc")('account/account')) + ":\n\t\t\t\t\t\t"), _vm._v(" "), (_vm.$store.state.user_type === 'admin') ? [(!_vm.account['global_filter'] || _vm.account['global_filter']['value'] != _vm.account['account_id']['value']) ? _c('font-awesome-icon', {
    staticClass: "global-filter-button",
    attrs: {
      "title": _vm._f("ftc")('account/filter'),
      "icon": "filter"
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter(_vm.account['account_id']['value'])
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.account['global_filter'] && _vm.account['global_filter']['value'] == _vm.account['account_id']['value']) ? _c('font-awesome-layers', {
    staticClass: "global-filter-button global-filter-button-remove",
    attrs: {
      "title": _vm._f("ftc")('main/delete ' + _vm.localeFtc('main/filter').toLowerCase())
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter()
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "filter"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": "times"
    }
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('linkComponent', {
    attrs: {
      "url": '/account/view/' + _vm.account['account_id']['value'],
      "text": _vm.account['account_name']['value']
    }
  })], 2) : _vm._e(), _vm._v(" "), (_vm.sshkey && _vm.sshkey['key_id'] && _vm.sshkey['key_id']['value'] && _vm.sshkey['key_name'] && _vm.sshkey['key_name']['value']) ? _c('span', {
    staticClass: "margin-right-10"
  }, [_c('br', {
    staticClass: "visible-xs"
  }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('sshkey/sshkey')) + ": "), _c('linkComponent', {
    attrs: {
      "url": '/sshkey/view/' + _vm.sshkey['key_id']['value'],
      "text": _vm.sshkey['key_name']['value']
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs margin-top-20"
  }, _vm._l((_vm.tabs), function(tab) {
    return (_vm.tabVisible(tab.id)) ? _c('li', {
      key: tab.id,
      class: {
        active: tab.id === _vm.curTab
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.choiceTab(tab.id)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(tab.title)))])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.tabVisible('command')) ? _c('tabCommand', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'command'
    },
    attrs: {
      "access": _vm.Access,
      "status": _vm.serviceStatusClear,
      "serviceStatus": _vm.serviceStatus,
      "templateName": _vm.templateName,
      "vdsId": _vm.id,
      "canReboot": _vm.canReboot,
      "serviceName": _vm.serviceName,
      "iso": _vm.isoInfo,
      "serviceFullName": _vm.serviceFullName,
      "active": _vm.curTab === 'command',
      "serviceProlong": _vm.serviceProlong,
      "serviceCanProlong": _vm.serviceCanProlong,
      "serviceCanDelete": _vm.serviceCanDelete,
      "templateInstruction": _vm.templateInstruction,
      "parentError": _vm.localErrorMessage,
      "reserveIpData": _vm.reserveIpData
    },
    on: {
      "successMessage": _vm.onSuccessMessage,
      "updateData": _vm.updateData,
      "requestData": _vm.refreshVDSData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('access')) ? _c('tabAccess', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'access'
    },
    attrs: {
      "access": _vm.Access,
      "status": _vm.serviceStatusClear,
      "serviceStatus": _vm.serviceStatus,
      "vdsId": _vm.id,
      "vdsInfo": _vm.vdsData,
      "serviceFullName": _vm.serviceFullName,
      "templateName": _vm.templateName,
      "active": _vm.curTab === 'access',
      "parentError": _vm.localErrorMessage,
      "passwordType": _vm.passwordType
    },
    on: {
      "successMessage": _vm.onSuccessMessage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('plan')) ? _c('tabPlan', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'plan'
    },
    attrs: {
      "access": _vm.Access,
      "status": _vm.serviceStatusClear,
      "serviceStatus": _vm.serviceStatus,
      "vdsId": _vm.id,
      "plan": _vm.planInfo,
      "templateData": _vm.templateInfo,
      "value": _vm.servicePlanId,
      "parentError": _vm.localErrorMessage
    },
    on: {
      "successMessage": _vm.onSuccessMessage,
      "dropPlanConstructorChanged": _vm.onDropPlanConstructorChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('reinstall')) ? _c('tabReinstall', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'reinstall'
    },
    attrs: {
      "access": _vm.Access,
      "status": _vm.serviceStatusClear,
      "serviceStatus": _vm.serviceStatus,
      "vdsId": _vm.id,
      "template": _vm.templateInfo,
      "host": _vm.hostInfo,
      "sshkey": _vm.sshkeyInfo,
      "account": _vm.account,
      "backup": _vm.backupInfo && _vm.backupInfo['backup_id'] ? _vm.backupInfo['backup_id'] : null,
      "reiso": _vm.reisoInfo,
      "dc": _vm.dataCenter,
      "planId": _vm.servicePlanId,
      "planData": _vm.planInfo,
      "value": _vm.serviceTemplateId,
      "parentError": _vm.localErrorMessage,
      "vdsName": _vm.serviceName
    },
    on: {
      "successMessage": _vm.onSuccessMessage,
      "flagCloseModals": function (value) { return _vm.notCloseModals = value; }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('ip')) ? _c('tabIp', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'ip'
    },
    attrs: {
      "active": _vm.curTab === 'ip',
      "status": _vm.serviceStatusClear,
      "serviceStatus": _vm.serviceStatus,
      "access": _vm.Access,
      "mainIP": _vm.serviceIPData,
      "ipInfo": _vm.ipInfo,
      "vdsId": _vm.id,
      "reserveIpData": _vm.reserveIpData,
      "reserveIPv4List": _vm.reserveIPv4List,
      "parentError": _vm.localErrorMessage
    },
    on: {
      "successMessage": _vm.onSuccessMessage,
      "updateData": _vm.updateData,
      "flagCloseModals": function (value) { return _vm.notCloseModals = value; }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('localIp')) ? _c('tabLocalIp', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'localIp'
    },
    attrs: {
      "status": _vm.serviceStatusClear,
      "serviceStatus": _vm.serviceStatus,
      "access": _vm.Access,
      "data": _vm.serviceLocalIPData,
      "vdsId": _vm.id,
      "ipLocalData": _vm.ipLocalData,
      "parentError": _vm.localErrorMessage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('backup')) ? _c('tabBackup', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'backup'
    },
    attrs: {
      "active": _vm.curTab === 'backup',
      "serviceStatus": _vm.serviceStatus,
      "access": _vm.Access,
      "backup": _vm.backupInfo && _vm.backupInfo['create'] ? _vm.backupInfo['create'] : null,
      "backupList": _vm.backupInfo && _vm.backupInfo['backup_id'] ? _vm.backupInfo['backup_id'] : null,
      "vdsId": _vm.id,
      "vdsName": _vm.serviceName,
      "account": _vm.account,
      "dc": _vm.dataCenter,
      "vdsInfo": _vm.vdsData,
      "planInfo": _vm.servicePlanInfo,
      "parentError": _vm.localErrorMessage
    },
    on: {
      "successMessage": _vm.onSuccessMessage,
      "updateData": _vm.updateData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('disks')) ? _c('tabDisks', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'disks'
    },
    attrs: {
      "active": _vm.curTab === 'disks',
      "serviceStatus": _vm.serviceStatus,
      "access": _vm.Access,
      "vdsId": _vm.id,
      "vdsName": _vm.serviceName,
      "account": _vm.account,
      "dc": _vm.dataCenter,
      "parentError": _vm.localErrorMessage
    },
    on: {
      "successMessage": _vm.onSuccessMessage,
      "updateData": _vm.updateData
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tabVisible('stat') && !_vm.localErrorMessage) ? _c('tabStat', {
    staticClass: "tab-pane",
    class: {
      active: _vm.curTab === 'stat'
    },
    attrs: {
      "active": _vm.curTab === 'stat',
      "planInfo": _vm.servicePlanInfo,
      "trafInfo": _vm.trafInfo,
      "localIpInfo": _vm.serviceLocalIPData,
      "vdsId": _vm.id
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNameModal),
      expression: "showNameModal"
    }],
    staticClass: "modal-mask",
    on: {
      "mousedown": function($event) {
        _vm.maskModalFlag = true
      },
      "mouseup": function () { return this$1.hideNameModal(false); }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      },
      "mouseup": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/name')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideNameModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.nameField,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "focus": _vm.onFocusName,
      "enterKeyDown": _vm.nameChangeStart
    },
    model: {
      value: (_vm.nameValue),
      callback: function($$v) {
        _vm.nameValue = $$v
      },
      expression: "nameValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.nameChangeStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/rename_action')))])])])])])])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    key: "transitionSuccess",
    attrs: {
      "name": "fallingBlock"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localSuccessMessage !== ''),
      expression: "localSuccessMessage !== ''"
    }],
    staticClass: "alert alert-success font-size-90 falling-block",
    staticStyle: {
      "margin-right": "10px",
      "word-break": "break-word"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localSuccessMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localSuccessMessage)) + "\n\t\t\t")])])] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ff454e2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crud/vdsView.vue
// module id = 649
// module chunks = 0